
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.778.662A.315.315 0 006.5.5a.315.315 0 00-.277.162L4.389 4.06a.313.313 0 01-.225.158l-3.903.64a.31.31 0 00-.246.204.296.296 0 00.074.306l2.77 2.738c.068.068.1.163.086.257l-.579 3.79a.3.3 0 00.126.29.322.322 0 00.323.026l3.546-1.703a.322.322 0 01.278 0l3.546 1.703c.104.05.229.04.323-.026a.3.3 0 00.126-.29l-.579-3.79a.297.297 0 01.086-.257l2.77-2.738a.296.296 0 00.074-.306.31.31 0 00-.246-.205l-3.903-.639a.313.313 0 01-.225-.158L6.778.662z"}})])
          )
        }
      }
    